import type {$Fetch} from "nitropack";
import type {SpokenLanguage} from "~/help/languages";

export interface ProfileUpdatePayload {
    first_name?: string;
    last_name?: string;
    title?: string;
    daily_rate?: number | null;
    location?: string;
    is_visible?: boolean;
    contact_email?: string;
    contact_phone?: string;
    whatsapp?: string;
    linkedin?: string;
    client_cases?: { url: string; title?: string }[];
    summary?: string;
    languages?: SpokenLanguage[];
}

export const ProfileRepository = (client: $Fetch) => ({

    update: (id: string, data: ProfileUpdatePayload, config: any = {}) => {
        return client('/v2/profiles/' + id, {
            method: 'PATCH',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            },
            ...config,
        }) as Promise<{
            profile: any;
            signed_picture_url?: string;
        }>;
    },

    uploadPresentationVideo: (id: string, file: File) => {
        const formData = new FormData();
        formData.append('video', file);
        return client(`/v2/profiles/${id}/presentation-video`, {
            method: 'POST',
            body: formData,
        }) as Promise<void>;
    },

    deletePresentationVideo: (id: string) => {
        return client(`/v2/profiles/${id}/presentation-video`, {
            method: 'DELETE',
        }) as Promise<void>;
    },

    uploadAudioDemo: (id: string, file: File) => {
        const formData = new FormData();
        formData.append('audio', file);
        return client(`/v2/profiles/${id}/audio-demo`, {
            method: 'POST',
            body: formData,
        }) as Promise<void>;
    },

    deleteAudioDemo: (id: string) => {
        return client(`/v2/profiles/${id}/audio-demo`, {
            method: 'DELETE',
        }) as Promise<void>;
    },

});